import axios from 'axios';

import { backOfficeAxeRequestInterceptor, backOfficeAxeResponseInterceptor } from './axeHelpers';
import { MANAGEMENT_SERVICE_API_URL } from '../../config';

const managementServisAxeClientBackoffice = axios.create();

managementServisAxeClientBackoffice.defaults.validateStatus = (status) => status < 500;

managementServisAxeClientBackoffice.interceptors.request.use(backOfficeAxeRequestInterceptor);

managementServisAxeClientBackoffice.interceptors.response.use((response) => response, backOfficeAxeResponseInterceptor);

managementServisAxeClientBackoffice.defaults.baseURL = `${MANAGEMENT_SERVICE_API_URL}/backoffice`;

export default managementServisAxeClientBackoffice;
